import { connect } from 'react-redux';
import { makeStyles, tokens } from '@fluentui/react-components';
import { AppState } from '../../../../redux/reducers';
import { ErrorType } from '../../../../models/HttpError';
import { Consultorio, Sector } from '../../../../models/Entities/Turnero';
import * as ConsultoriosStore from '../../../../redux/middleware/Turnero/Turnero.Consultorios.Middleware';
import * as SectoresStore from '../../../../redux/middleware/Turnero/Turnero.Sectores.Middleware';

export interface OwnProps {
  isOpen: boolean;
  onClose: () => void;
  defaultSectorId: number;
  branchId?: number;
  consultorioId?: number;
}

interface StateProps {
  isSaving: boolean;
  isSaved: boolean | undefined;
  failOnSaving: boolean;
  error: ErrorType | undefined;
  sectores: Sector[];
  currentConsultorio?: Consultorio;
}

interface DispatchProps {
  CreateConsultorio: typeof ConsultoriosStore.actionCreators.CreateConsultorio;
  UpdateConsultorio: typeof ConsultoriosStore.actionCreators.UpdateConsultorio;
  GetConsultorios: typeof ConsultoriosStore.actionCreators.GetConsultorios;
  GetSectores: typeof SectoresStore.actionCreators.GetSectores;
}

export type Props = OwnProps & StateProps & DispatchProps;

export const mapStateToProps = (state: AppState, own: OwnProps): StateProps => {
  const currentConsultorio = own.consultorioId
    ? (state.Turnero?.Consultorios?.list || []).find((c) => c.id === own.consultorioId)
    : undefined;

  const isAdding = state.Turnero?.Consultorios?.isAddingNewOne || false;
  const isUpdating = state.Turnero?.Consultorios?.isUpdatingOne || false;
  const isSavedAdd = state.Turnero?.Consultorios?.successAddingNewOne;
  const isSavedUpdate = state.Turnero?.Consultorios?.successUpdatingOne;
  const failAdd = state.Turnero?.Consultorios?.failOnAddingNewOne || false;
  const failUpdate = state.Turnero?.Consultorios?.failOnUpdatingOne || false;

  return {
    isSaving: isAdding || isUpdating,
    isSaved: own.consultorioId ? isSavedUpdate : isSavedAdd,
    failOnSaving: own.consultorioId ? failUpdate : failAdd,
    error: state.Turnero?.Consultorios?.error,
    sectores: state.Turnero?.Sectores?.list || [],
    currentConsultorio,
  };
};

export const mapDispatchToProps = {
  CreateConsultorio: ConsultoriosStore.actionCreators.CreateConsultorio,
  UpdateConsultorio: ConsultoriosStore.actionCreators.UpdateConsultorio,
  GetConsultorios: ConsultoriosStore.actionCreators.GetConsultorios,
  GetSectores: SectoresStore.actionCreators.GetSectores,
};

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: tokens.spacingHorizontalS,
  },
});

export const connector = connect(mapStateToProps, mapDispatchToProps);
